import React from 'react'
import PropTypes from 'prop-types'

import IconButton from 'components/common/IconButton'
import { ICON_MESSENGER } from 'components/common/Icon'

const SendMessageButton = ({ text, ...rest }) => {
  return <IconButton icon={ICON_MESSENGER} text={text} {...rest} />
}

SendMessageButton.propTypes = {
  text: PropTypes.string.isRequired
}

export default SendMessageButton



// WEBPACK FOOTER //
// ./src/components/common/SendMessageButton.js